/**
 * 上のバーの残高（2026-10-07 console/usage-view・founder「どの画面でも残高が見える」）。押すと残高の画面（/money/prepaid）へ。
 * 見た目の判断は usageView.ts balanceChip（$5 未満 = 黄と "Low"・止まっている = 赤・自動チャージ ON はその旨）。
 *
 * 取れないとき（読み込み中・古い本体・お金の API の一時的な失敗・閉鎖後）は何も出さない: 残高は補助で、止まっていることは
 * 帯（PrepaidBand）と 402 の案内が別に言う。60 秒ごとに読み直す（別タブで入金したら数字が変わる。帯の 30 秒より緩くてよい = 見るだけの数字）。
 * WHY 帯（PrepaidBand）と同じ GET を共有しないか: 上のバーはどの画面にもある（ホーム・プロジェクト・お金・アカウント）。
 *   共有の入れ物を作るほどの重さではない（GET 1 本・残高の行を読むだけ）= 部品を独立させる方を選んだ
 */
import { Link } from 'react-router-dom';
import { useResource } from '../hooks';
import { useT } from '../i18n';
import { money } from '../money';
import type { PrepaidView } from '../moneyApi';
import { balanceChip } from '../usageView';

export function BalanceChip() {
  const r = useResource<Pick<PrepaidView, 'balance' | 'owed' | 'currency' | 'canSpend' | 'balanceStatus' | 'autoTopUp' | 'invite'>>('/v1/money/prepaid', 60_000);
  const { t } = useT();
  if (!r.data || typeof r.data.balance !== 'number') return null;
  const { tone, autoTopUp } = balanceChip(r.data);
  const amount = money(r.data.balance, r.data.currency ?? 'usd');
  // 札（色つきの小さな字）: low = 残りわずか・out = 残高なし（使い切った）・pending = メール確認待ち（招待クレジットが確認で入る）・
  // start = まだ入れていない（「入金する」= 次にすること。2026-10-29 core/open-signup-polish: 招待なしの新しい人が「RAN OUT」だった）。ok は札なし
  const tag =
    tone === 'low' ? t('topbar.balanceLow')
    : tone === 'out' ? t('topbar.balanceOut')
    : tone === 'pending' ? t('topbar.balancePending')
    : tone === 'start' ? t('topbar.balanceStart')
    : '';
  const label = [t('topbar.balanceLabel', { amount }), tag, autoTopUp ? t('topbar.autoTopUp') : ''].filter(Boolean).join(' ');
  return (
    <Link to="/money/prepaid" className={`balance-chip balance-chip-${tone}`} aria-label={label} title={label}>
      <span className="balance-chip-amount">{amount}</span>
      {tag && <span className="balance-chip-tag">{tag}</span>}
      {autoTopUp && <span className="balance-chip-auto">{t('topbar.autoTopUp')}</span>}
    </Link>
  );
}
